<template>
  <div>
    <vs-button ref="loadBtn" color="secondary" type="border" @click="showLoadRiskPost = true">위험성평가 정보 불러오기</vs-button>
    <p style="font-size: 16px; line-height: 17px" class="mb-5">※ [<b>위험성평가</b>(유해·위험요인 파악) → <b>위험성평가회의</b>(위험성평가의 공유) → <b>교육·TBM 전파</b>(위험성 결정, 감소대책 수립) → <b>이행확인</b>(감소대책 실행)]</p>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="{ ...board, readonly: true }" :is-print="isPrint"  />

    <!-- 위험성평가 -->
    <RiskTable v-model="form.riskList" class="mb-6" readonly :is-print="isPrint"/>

    <!-- 주간 이행사항 점검 및 회의 -->
    <ImplementationTable :readonly="board.readonly" v-model="form.implement" class="mb-6" :is-print="isPrint"/>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <!-- Post 불러오기 팝업 -->
    <PopupLoadPrevBoard title="위험성평가 정보 불러오기" :setBoardId="475" v-model="showLoadRiskPost" @selectRowData="loadRiskPost" />
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import RiskTable from "../475/RiskTable.vue";
import ImplementationTable from "./ImplementationTable.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    RiskTable,
    ImplementationTable,
    DateSelector,
    FileUploader,
    PopupLoadPrevBoard,
  },
  props: {
    isPrint: Boolean,
    header: Object,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      headerDate: { required },
      stdInfo: {
        field_name: { required },
      },
    },
  },
  watch: {
    "header": {
      immediate: true,
      deep: true,
      handler(value) {
        const year = value.year;
        const month = Number(`${value.month}`);
        this.form.headerDate = `${year}-${month < 10 ? `0${month}` : month}`;
      },
    },
    "value": {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    "form": {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
    'form.implement': {
      deep: true,
      handler(value) {
        this.form.implementCheck = ""
        for (const implement of value) {
          this.form.implementCheck += `${implement.input2} `
        }

        this.$emit("input", this.form);
      },
    },
  },
  data() {
    return {
      showLoadRiskPost: false,
      form: {
        headerDate: "",
        stdInfo: {},
        fileList: [],
        riskList: [],
        implement: [],

        implementCheck: "",

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: {},
        inputA_6: "",
      },
    };
  },
  mounted() {
    const buttonContainer = document.querySelector("#right-button-container");
    const loadBtn = this.$refs.loadBtn;
    buttonContainer.prepend(loadBtn.$el);
  },
  methods: {
    loadRiskPost(data) {
      this.form.headerDate = data.headerDate;
      this.form.stdInfo = data.stdInfo;
      this.form.riskList = data.riskList;

      this.form.inputA_1 = data.inputA_1;
      this.form.inputA_2 = data.inputA_2;
      this.form.inputA_3 = data.inputA_3;
      this.form.inputA_4 = data.inputA_4;
      this.form.inputA_5 = data.inputA_5;
      this.form.inputA_6 = data.inputA_6;
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "위험성평가 정보는 반드시 불러와야 합니다";
      }
    },
  },
};
</script>
